import * as React from 'react';

export default class Clock extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
        <svg className={this.props.className} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" >
            <g fill="none" fillRule="evenodd">
                <g stroke="">
                    <g>
                        <g>
                            <g>
                                <g>
                                    <g>
                                        <g>
                                            <g>
                                                <g transform="translate(-494 -228) translate(68 221) translate(425.467 7) translate(.533)">
                                                    <ellipse cx="7.591" cy="7" rx="4.124" ry="4"/>
                                                    <path d="M7.591 4.5L7.591 7.462 9.798 7.462M9.135 10.429L10.689 12"/>
                                                    <path d="M4.467 10.372L5.954 12" transform="matrix(-1 0 0 1 10.421 0)"/>
                                                </g>
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    )
  }
}
